var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNonVerifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7966 3.88635C19.7966 3.48023 19.4582 3.11923 19.0295 3.07411C17.5855 2.89361 16.1867 2.57774 14.8555 2.10393C13.4341 1.60756 11.9224 0.953255 10.343 0.118452C10.0497 -0.039484 9.75642 -0.039484 9.46311 0.118452C7.90631 0.953255 6.37208 1.60756 4.97322 2.08137C3.64205 2.53261 2.22062 2.87105 0.799202 3.05155C0.370519 3.09667 0.0546476 3.4351 0.00952311 3.86379C-0.12585 9.32385 1.18276 13.8589 3.89023 17.356C5.37934 19.2738 7.25201 20.8306 9.46311 22.0038C9.57592 22.0941 9.73386 22.1167 9.91436 22.1167C10.0723 22.1167 10.2302 22.0715 10.3882 22.0038C12.6218 20.808 14.4719 19.2287 15.9385 17.356C18.6234 13.904 19.932 9.36898 19.7966 3.88635ZM14.4719 16.431C13.2761 17.9652 11.7419 19.2964 9.91436 20.3568C8.08681 19.2964 6.53002 17.9652 5.35678 16.431C2.98774 13.3625 1.8145 9.39154 1.8145 4.6309C3.07799 4.42784 4.31891 4.11197 5.65009 3.66073C6.9587 3.20948 8.40268 2.6003 9.91436 1.83318C11.4486 2.6003 12.87 3.20948 14.1786 3.66073C15.4647 4.08941 16.7507 4.42784 18.0142 4.6309C18.0142 9.43666 16.841 13.3851 14.4719 16.431Z",
    fill: "#FB8C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonVerifiedIcon);
export default __webpack_public_path__ + "static/media/nonVerifiedIcon.ee0517d7b0436ff3cfa61135c70f6f22.svg";
export { ForwardRef as ReactComponent };